<template>
  <div>
    <v-row dense>
      <v-col sm="4" align="center" class="DetailSampleHeader">
        <h5>{{ siteName }}</h5>
        <h5>{{ point }}</h5>
        <h5>{{ desc }}</h5>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col sm="5" class="DetailHeader">
        <h5>Batch ID:- {{ batch }}</h5>
        <h5>Lot ID:- {{ lot }}</h5>
        <h5>Material:- {{ mat }}</h5>
        <h5>Comment:- {{ comment }}</h5>
      </v-col>
    </v-row>
<v-card class="table_style">
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th align="center" class="primary white--text"></th>
                <th class="primary white--text"></th>
                <th class="primary black--text" v-if="sdetails.length > 0">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        {{ sdetails[0].sample_time | subStrDate }} <br />
                        {{ sdetails[0].sample_time | subStrTime }} <br />
                        {{ sdetails[0].status }}
                      </div>
                    </template>
                    <span>
                      <span v-if="sdetails[0].description != ''">
                        Sample Description : {{ sdetails[0].description }}<br
                      /></span>
                      <span v-if="sdetails[0].lims_unique_id != ''">
                        LIMS ID : {{ sdetails[0].lims_unique_id }}<br
                      /></span>
                      <span v-if="sdetails[0].batch_id != ''">
                        Batch ID : {{ sdetails[0].batch_id }}<br
                      /></span>
                      <span v-if="sdetails[0].lot_id != ''">
                        Lot ID : {{ sdetails[0].lot_id }}<br
                      /></span>
                      <span v-if="sdetails[0].product_id != ''">
                        Product : {{ sdetails[0].product_id }}<br
                      /></span>
                      <span v-if="sdetails[0].material_number != ''">
                        Material : {{ sdetails[0].material_number }},{{
                          sdetails[0].material_description
                        }}<br
                      /></span>
                      <span v-if="sdetails[0].comment != ''">
                        Comment : {{ sdetails[0].comment }}<br
                      /></span>
                    </span>
                  </v-tooltip>
                </th>
                <th class="primary black--text">Low limit</th>
                <th class="primary black--text">High limit</th>
                <th
                  class="primary black--text"
                  v-for="(sample, i) in sdetails"
                  :key="`sampleHeader-${i}`"
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-if="i > 0" v-bind="attrs" v-on="on">
                        <!-- <router-view :key="`/limsds/Sample-Detail?site=${sample.site}&s_Key=${sample.s_key}&arrival_time=${sample.arrival_UTCtime}`"></router-view> -->
                        <router-link @click.native="refreshPage" class="primary black--text" :to="`/limsds/Sample-Detail?site=${sample.site}&s_Key=${sample.s_key}&arrival_time=${sample.arrival_UTCtime}`" > {{ sample.sample_time | subStrDate }}</router-link>
                        <!-- <a target="_blank"
                          class="primary black--text"
                          :href="`/#/limsds/Sample-Detail?site=${sample.site}&s_Key=${sample.s_key}&arrival_time=${sample.arrival_UTCtime}`"
                        >
                          {{ sample.sample_time | subStrDate }}
                        </a>  -->
                        <br />
                        {{ sample.sample_time | subStrTime }} <br />
                        {{ sample.status }}
                      </div>
                    </template>
                    <span>
                      <span v-if="sample.description != ''">
                        Sample Description : {{ sample.description }}<br
                      /></span>
                      <span v-if="sample.lims_unique_id != ''">
                        LIMS ID : {{ sample.lims_unique_id }}<br
                      /></span>
                      <span v-if="sample.batch_id != ''">
                        Batch ID : {{ sample.batch_id }}<br
                      /></span>
                      <span v-if="sample.lot_id != ''">
                        Lot ID : {{ sample.lot_id }}<br
                      /></span>
                      <span v-if="sample.product_id != ''">
                        Product : {{ sample.product_id }}<br
                      /></span>
                      <span v-if="sample.material_number != ''">
                        Material : {{ sample.material_number }},{{
                          sample.material_description
                        }}<br
                      /></span>
                      <span v-if="sample.comment != ''">
                        Comment : {{ sample.comment }}<br
                      /></span>
                    </span>
                  </v-tooltip>
                </th>
              </tr>
            </thead>
            <tbody v-if="sampleComponents.length > 0">
              <tr
                v-for="(item, index) in sampleComponents"
                :key="`sampleComponent-${index}`"
              >
                <td>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        {{ item.Name }}
                      </div>
                    </template>
                    <span>
                      <span> {{ item.Name }}<br /></span>
                      <span> Test Id : {{ item.testId }}<br /></span>
                      <span>
                        Test Procedure : {{ item.test_procedure }}<br
                      /></span>
                    </span>
                  </v-tooltip>
                </td>
                <td >{{ item.eng_unit }}</td>
                <td :class="itemOff_specBg(item)">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        {{
                          sdetails[0].Componentchildren.find(
                            (x) =>
                              x.Name.toLowerCase() == item.Name.toLowerCase()
                          )
                            ? sdetails[0].Componentchildren.find(
                                (x) =>
                                  x.Name.toLowerCase() ==
                                  item.Name.toLowerCase()
                              ).value
                            : ""
                        }}
                      </div>
                    </template>
                    <span>
                      <span> Low limit : {{ item.lo_spec }}<br /></span>
                      <span> High Limit : {{ item.hi_spec }}<br /></span>
                      <span> Eng Unit : {{ item.eng_unit }}<br /></span>
                    </span>
                  </v-tooltip>
                </td>
                <td class="DetailSpecHeader">{{ item.lo_spec }}</td>
                <td class="DetailSpecHeader">{{ item.hi_spec }}</td>
                <td 
                  v-for="(sample, idx) in sdetails"
                  :key="`sampleItem-${idx}`"
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-if="idx > 0" v-bind="attrs" v-on="on">
                        {{
                          sample.Componentchildren.find(
                            (x) =>
                              x.Name.toLowerCase() == item.Name.toLowerCase()
                          )
                            ? sample.Componentchildren.find(
                                (x) =>
                                  x.Name.toLowerCase() ==
                                  item.Name.toLowerCase()
                              ).value
                            : ""
                        }}
                      </div>
                    </template>
                    <span>
                      <span> Low limit : {{ item.lo_spec }}<br /></span>
                      <span> High Limit : {{ item.hi_spec }}<br /></span>
                      <span> Eng Unit : {{ item.eng_unit }}<br /></span>
                    </span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        </v-card>
  </div>
</template>

<script>
import axios from "axios";
import uiView from "@/_mixins/ui-view-mixin";
import appMixin from "../mixins/app-mixin";
import notificationMixin from "@/_mixins/notification-mixin";
export default {
  name: "SampleDetail",
  mixins: [uiView, appMixin, notificationMixin],
  components: {},
  props: {
    s_Key: { type: String, default: null },
    site: { type: String, default: null },
  },
  computed: {
    sKeyComp() {
      var querySkey = this.$router.currentRoute.query?.s_Key;
      return querySkey || this.s_Key;
    },
    siteComp() {
      var querySite = this.$router.currentRoute.query?.site;
      return querySite || this.site;
    },
    sampleComponents: function () {
      if (this.sdetails.length == 0) return [];
      let test = [];
      this.sdetails.forEach((element) => {
        var tempList = element.Componentchildren.filter(
          (x) => test.findIndex((y) => y.Name == x.Name) == -1
        );
        const tempListWithProps = tempList.map((x) => ({
          ...x,
          testId: this.componentOrder.find(
            (y) => y.Name.toLowerCase() == x.Name.toLowerCase()
          )?.test_id,
          test_procedure: this.componentOrder.find(
            (y) => y.Name.toLowerCase() == x.Name.toLowerCase()
          )?.test_procedure,
          
          comp_Order: this.componentOrder.find(
            (y) => y.Name.toLowerCase() == x.Name.toLowerCase()
          )?.componentOrder,
          test_Order: this.componentOrder.find(
            (y) => y.Name.toLowerCase() == x.Name.toLowerCase()
          )?.testOrder,
        }));
       test.push(...tempListWithProps);
        if (this.limsds_userPreference.ComponentOrder == 1) {
          test.sort((a, b) => a.test_Order - b.test_Order );
          test.sort((a, b) => a.t_key - b.t_key );
          test.sort((a, b) => a.comp_Order - b.comp_Order );
          console.log(test.map(x => ({key: x.t_key, order: x.test_Order , COrder :x.comp_Order})));
         
        }
      });
        return test;
    },

    siteName: function () {
      if (!this.defaultValues.SampleDetailList1) {
        return "";
      } else {
        return this.defaultValues.SampleDetailList1.Site;
      }
    },
    point: function () {
      if (!this.defaultValues.SampleDetailList1) {
        return "";
      } else {
        return this.defaultValues.SampleDetailList1.Point;
      }
    },
    desc: function () {
      if (!this.defaultValues.SampleDetailList1) {
        return "";
      } else {
        return this.defaultValues.SampleDetailList1.Description;
      }
    },
    batch: function () {
      if (!this.defaultValues.SampleDetailList1) {
        return "";
      } else {
        return this.defaultValues.SampleDetailList1.BatchId;
      }
    },
    lot: function () {
      if (!this.defaultValues.SampleDetailList1) {
        return "";
      } else {
        return this.defaultValues.SampleDetailList1.LotId;
      }
    },
    mat: function () {
      if (!this.defaultValues.SampleDetailList1) {
        return "";
      } else {
        return this.defaultValues.SampleDetailList1.Material;
      }
    },
    comment: function () {
      if (!this.defaultValues.SampleDetailList1) {
        return "";
      } else {
        return this.defaultValues.SampleDetailList1.Comment;
      }
    },
  },
  data() {
    return {
      DateFormat: null,
      ukey: null,
      list: {},
      sdetails: [],
      componentOrder: [],
      componentOrderSort: [],
      defaultValues: {
        SampleDetailList: [],
        SampleDetailList1: [],
        s_Key: null,
        site: null,
        limsInternal: 0,
        sampleBack: null,
      },
    };
  },
  filters: {
    subStrDate: function (string) {
      return string.substring(0, 10);
    },
    subStrTime: function (string) {
      return string.substring(11, 20);
    },
  },
  mounted() {},
  
  methods: {
    refreshPage: function()
    {this.$router.go()},
    itemOff_specBg: function (item) {
      if (item.off_spec.toLowerCase() != "no") {
        return "DetailOffSpec";
      } else  {
        return "";
      } 
    },
    getSampleDetail() {
      var that = this;
      const SampleDetailLink1 =
        that.settings.WASampleDetail +
        "site=" +
        this.siteComp +
        "&S_Key=" +
        this.sKeyComp +
        "&userid=" +
        this.limsds_userDetails.userEmail +
        "&ipaddress=10.15.0.68&lims_internal=" +
        this.defaultValues.limsInternal +
        "&samplesback=" +
        that.defaultValues.sampleBack;
      axios.get(SampleDetailLink1).then((response) => {
        // that.defaultValues.SampleDetailList1 = [];
        //  that.componentOrder=[];
        //  that.sdetails=[];
        that.defaultValues.SampleDetailList1 = response.data;
        that.componentOrder.push(...response.data.componentOrder);
        that.sdetails.push(...response.data.samples);
        
      });
    },
  },
  created() {
    this.defaultValues.s_Key = this.s_Key;
    this.defaultValues.site = this.site;
    if (this.limsds_userDetails.userEmail != null) {
      this.list = this.limsds_userPreference;
      this.DateFormat = this.list.Dateformat;
      this.defaultValues.limsInternal = this.list.Limsinternal;
      this.defaultValues.sampleBack = this.list.Samplesback;
      if (this.defaultValues.sampleBack <= 0) {
        this.defaultValues.sampleBack = 3;
      }
      if (this.defaultValues.sampleBack >= 10) {
        this.defaultValues.sampleBack = 10;
      }
      this.getSampleDetail();
    }

    if (!this.sKeyComp || !this.siteComp) {
      this.addNotification({
        message: "Site or s_Key are not supplied...",
        type: "info",
        description: "Sample Detail site and S_Key values requires !!!",
        delay: 10000,
        top: true,
        right: true,
      });
    }
  },
};
</script>

<style lang="scss">
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-size: 0.875rem;
  height: 8px !important;
  padding: 0 5px !important;
}
.v-data-table > .v-data-table__wrapper > table {
    width: auto !important;
    
}
.table_style 
{width : auto; display : inline-block}
</style>